
import React from "react";
import { Label } from "@/components/ui/label";
import { formatCurrency } from "../../utils/formatters";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface ClosingCostTotalProps {
  total: number;
  sellerCreditAmount?: number;
}

const ClosingCostTotal: React.FC<ClosingCostTotalProps> = ({ total, sellerCreditAmount = 0 }) => {
  const adjustedTotal = Math.max(total - sellerCreditAmount, 0);
  const hasSellerCredit = sellerCreditAmount > 0;

  return (
    <div className="space-y-2 pt-3 border-t">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Total Closing Costs <MetricTooltip metric="totalClosingCosts" /></Label>
        <span className="font-semibold text-foreground">{formatCurrency(total)}</span>
      </div>
      
      {hasSellerCredit && (
        <>
          <div className="flex items-center justify-between text-green-600">
            <Label className="text-sm">Seller Credit Applied</Label>
            <span className="font-medium">-{formatCurrency(sellerCreditAmount)}</span>
          </div>
          
          <div className="flex items-center justify-between border-t pt-2">
            <Label className="text-sm font-bold">Adjusted Closing Costs</Label>
            <span className="font-bold text-foreground">{formatCurrency(adjustedTotal)}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default ClosingCostTotal;
